var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21582 6.50977H20.7845C21.4548 6.50977 22 6.06133 22 5.50988C22 4.95844 21.4548 4.50977 20.7845 4.50977H3.21582C2.54544 4.50977 2 4.95844 2 5.50988C2 6.06133 2.54544 6.50977 3.21582 6.50977ZM20.7845 10.7842H3.21582C2.54544 10.7842 2 11.2329 2 11.7843C2 12.3357 2.54544 12.7842 3.21582 12.7842H20.7845C21.4548 12.7842 22 12.3357 22 11.7843C22 11.2329 21.4548 10.7842 20.7845 10.7842ZM3.21582 17.0586H20.7845C21.4549 17.0586 22 17.5074 22 18.0588C22 18.6102 21.4548 19.0586 20.7845 19.0586H3.21582C2.54544 19.0586 2 18.6102 2 18.0588C2 17.5074 2.54544 17.0586 3.21582 17.0586Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.53ae73316e0d0c1bc9ae5e311ca9208e.svg";
export { ForwardRef as ReactComponent };